import { useState, useMemo } from 'react';

/**
 * Hook genérico para filtrar uma lista de objetos baseando-se em um termo de busca e um array de propriedades.
 *
 * @param {Array} dataList - A lista original (inteira) de dados
 * @param {Array} searchFields - Array de strings indicando as propriedades a serem pesquisadas (ex: ['name', 'description'])
 * @param {Function} customMatcher - Função opcional que recebe (item, lowerSearch) e retorna bool. Se retornar true, o item é incluído.
 * @returns {Object} { searchTerm, setSearchTerm, filteredData }
 */
export const useSearch = (dataList = [], searchFields = ['name'], customMatcher = null) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredData = useMemo(() => {
        if (!searchTerm) return dataList;
        const lowerSearch = searchTerm.toLowerCase();

        return dataList.filter(item => {
            if (customMatcher && customMatcher(item, lowerSearch)) {
                return true;
            }

            return searchFields.some(field => {
                const value = item[field];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(lowerSearch);
                }
                return false;
            });
        });
    }, [dataList, searchTerm, searchFields, customMatcher]);

    return {
        searchTerm,
        setSearchTerm,
        filteredData
    };
};
